import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-information-layout',
  templateUrl: './information-layout.component.html',
  styleUrls: ['./information-layout.component.css']
})
export class InformationLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
